<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="data[modifyIndex].date"
        label="Date"
        prepend-icon="event"
        readonly
        v-on="on"></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="data[modifyIndex].date"
      type="month"
      :max="new Date().toISOString().substr(0, 10)"
      min="1900-01-01"
      scrollable>
      <v-spacer></v-spacer>
      <!-- <v-btn text color="primary" @click="menu = false">Cancel</v-btn> -->
      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    data: Array,
    modifyIndex: Number
  },
  mounted () {

  },
  methods: {

  },
  data: () => ({
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    modal: false
  }),
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
